/**
 * Comparaison de routes de menu (backend) avec l'URL courante du routeur.
 *
 * Les routes de menu viennent de l'API, concaténées segment par segment. Elles ne
 * correspondent pas toujours exactement à l'URL affichée : casing, slash de bord,
 * query string, et surtout dernier segment « écran » (`/List`, `/Overview`) alors
 * que l'utilisateur est sur `/Details/:id` du même écran.
 */

/** Query string retirée, minuscules, slashs de bord retirés. */
export function normalizeRoute(route: string): string {
  return (route ?? '')
    .split('?')[0]
    .toLowerCase()
    .replace(/^\//, '')
    .replace(/\/$/, '');
}

/** Segments non vides d'une route normalisée. */
export function routeSegments(route: string): string[] {
  return normalizeRoute(route)
    .split('/')
    .filter((segment) => !!segment);
}

/** Nombre de segments de tête communs à deux routes découpées. */
export function commonSegmentCount(a: string[], b: string[]): number {
  const max = Math.min(a.length, b.length);
  let count = 0;
  while (count < max && a[count] === b[count]) count++;
  return count;
}
